import e from "react";
import { Route as t } from "react-router-dom";
import { ApplyAppLayout as n } from "@maat/ds-app-layout";
import { Fragment as r, jsx as i } from "react/jsx-runtime";
//#region src/PublicRoute.tsx
var a = ({ children: a, render: o, layout: s, fallback: c, ...l }) => {
	let u = (t) => {
		let l = o ? o(t) : /* @__PURE__ */ i(r, { children: a });
		return s !== void 0 && (l = /* @__PURE__ */ i(n, {
			layout: s,
			children: l
		})), c === void 0 ? l : /* @__PURE__ */ i(e.Suspense, {
			fallback: c,
			children: l
		});
	};
	return /* @__PURE__ */ i(t, {
		...l,
		render: u
	});
};
//#endregion
export { a as PublicRoute };
